import { render, staticRenderFns } from "./OrderCustomerUnEvaluated.vue?vue&type=template&id=5f869171&"
import script from "./OrderCustomerUnEvaluated.vue?vue&type=script&lang=ts&"
export * from "./OrderCustomerUnEvaluated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports